import React, {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useState,
} from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  type DeviceContextState,
  testBuilderCustomAlertStateAtom,
} from "@/routes/test-builder-page";
import { useSetAtom } from "jotai";

const SelectCommandDialog = ({
  open,
  handleClose,
  setDeviceContextState,
  options,
}: {
  open: boolean;
  handleClose: () => void;
  options: string[];
  setDeviceContextState: Dispatch<SetStateAction<DeviceContextState>>;
}) => {
  const setTestBuilderCustomAlertState = useSetAtom(
    testBuilderCustomAlertStateAtom
  );

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const onClose = useCallback(() => {
    setSelectedOption(null);
    handleClose();
  }, [handleClose]);

  const onCopy = useCallback(() => {
    const clipboardText =
      selectedOption ??
      (options != null && options.length > 0 ? options.at(0)! : "");
    navigator.clipboard.writeText(clipboardText);

    setTestBuilderCustomAlertState({
      open: true,
      autoclose: true,
      type: "info",
      title: "Copied to clipboard",
      description: clipboardText,
    });

    setDeviceContextState((prev) => ({ ...prev, uiInspectorEnabled: false }));
    onClose();
  }, [
    selectedOption,
    options,
    setTestBuilderCustomAlertState,
    setDeviceContextState,
    onClose,
  ]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth={"md"} fullWidth>
      <DialogTitle>Select a Command</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
          >
            {options.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={option}
                onClick={() => {
                  console.log("option", option);
                  setSelectedOption(option);
                }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color={"error"} onClick={handleClose}>
          Cancel
        </Button>
        <Button
          onClick={onCopy}
          disabled={!selectedOption}
          variant={"contained"}
        >
          Copy Command
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectCommandDialog;
